import { Box, Button, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import '../../auth-dialog.scss';
import { useMemo } from 'react';
import { AuthUser } from 'aws-amplify/auth';

interface AuthHeaderProps {
  onClose: () => void;
  activePage: string;
  setActivePage: (value: string) => void;
  user: AuthUser | undefined | null;
}

export const AuthHeader = ({
  setActivePage,
  activePage,
  onClose,
  user,
}: AuthHeaderProps) => {
  const navigate = () => {
    if (activePage === 'auth2' || activePage === 'login') {
      setActivePage('auth');
    } else {
      setActivePage('login');
    }
  };

  const title = useMemo(() => {
    if (activePage === 'auth') {
      return 'Create Account';
    } else if (activePage === 'auth2') {
      return 'Almost There!';
    } else if (activePage === 'verify') {
      return 'One More Thing...';
    } else if (activePage === 'forgot_password') {
      return 'Reset Password';
    } else if (activePage === 'new_password') {
      return 'Update Password';
    } else {
      return 'Sign In';
    }
  }, [activePage]);

  const renderBackButton = useMemo(() => {
    if (user?.userId) {
      return false;
    } else {
      return activePage !== 'login';
    }
  }, [user, activePage]);

  return (
    <Box className="header" data-testid="auth-header">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {renderBackButton && (
          <Button onClick={() => navigate()} variant="transparent">
            <ArrowBackIcon />
          </Button>
        )}
        <Button onClick={onClose} variant="transparent">
          <CloseIcon />
        </Button>
      </Box>

      <DialogTitle
        sx={{ padding: '12px', fontSize: '45px', textAlign: 'center' }}
        id="auth-dialog-title"
      >
        {title}
      </DialogTitle>
    </Box>
  );
};
